import { useState } from 'react';
import { faqData } from '@/mocks/faqData';

export default function FAQSection() {
  const [openIds, setOpenIds] = useState<string[]>(['faq-1']);

  const toggleFAQ = (id: string) => {
    setOpenIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-600 mb-3">
              Frequently Asked Questions
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900">
              Everything About Hipobuy Spreadsheet
            </h2>
            <p className="text-sm text-foreground-600 mt-3">
              Find answers to the most common questions about using spreadsheets for smarter shopping research
            </p>
          </div>

          <div className="space-y-3">
            {faqData.map((faq) => {
              const isOpen = openIds.includes(faq.id);
              return (
                <div
                  key={faq.id}
                  className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-200"
                >
                  <button
                    onClick={() => toggleFAQ(faq.id)}
                    className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                      {faq.question}
                    </span>
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                      <i
                        className={`ri-${
                          isOpen ? 'subtract' : 'add'
                        }-line text-foreground-500 text-lg transition-transform duration-300 ${
                          isOpen ? 'rotate-180' : ''
                        }`}
                      ></i>
                    </div>
                  </button>
                  <div
                    className={`overflow-hidden transition-all duration-300 ${
                      isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                    }`}
                  >
                    <div className="px-5 pb-4">
                      <p className="text-sm text-foreground-600 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqData.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}